import { Injectable } from "@angular/core";
import {HttpClient,HttpHeaders} from "@angular/common/http"
import { ConfigService } from "../shared/utils/config.service";
import { CityModel } from "../models/city.model";
import { map } from "rxjs";

@Injectable()
export class CityService {

    baseUrl: string = '';

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.baseUrl = configService.getApiURI();
    };

    getCitys() {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)
       
        return this.http.get(this.baseUrl + '/citys', { headers: headers })
            .pipe(map((res:any) => {
                return res;
            }));
    }

    getCity(id: number) {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.get(this.baseUrl + '/citys/' + id, { headers: headers })
            .pipe(map((res:any) => {
                return res;
            }));
    }

    getCityStateId(id: number) {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.get(this.baseUrl + '/citystate/' + id, { headers: headers })
            .pipe(map((res:any) => {
                return res;
            }));
    }

    create(city: CityModel) {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.post(this.baseUrl + '/citys', city, { headers: headers })
            .pipe(map((res:any) => {
                return res;
            }));
    }



    update(city: CityModel) {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.put(this.baseUrl + '/citys/' + city.id, city, { headers: headers})
            .pipe(map((res:any) => {
                return res;
            }));
    }

    delete(id: number) {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.delete(this.baseUrl + '/citys/' + id, { headers: headers})
            .pipe(map((res:any) => {
                return res;
            }));

    }

}